import { forwardRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import r, { css } from 'styled-components';
import { jsx } from 'react/jsx-runtime';

var z=css`
  font-size: var(--icon-size-x-small);
`,m=css`
  font-size: var(--icon-size-small);
`,f=css`
  font-size: var(--icon-size-regular);
`,g=css`
  font-size: var(--icon-size-large);
`,$=css`
  font-size: var(--icon-size-x-large);
`,p=r(FontAwesomeIcon)`
  ${o=>o.$size==="x-small"&&z}
  ${o=>o.$size==="small"&&m}
  ${o=>o.$size==="regular"&&f}
  ${o=>o.$size==="large"&&g}
  ${o=>o.$size==="x-large"&&$}

  ${({$colorToken:o})=>o&&`color: var(--${o});`}

  /* Anti-aliasing icons cross-browsers */
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
`,s=forwardRef(({colorToken:o="",icon:i,size:n="regular",...t},l)=>i?jsx(p,{$colorToken:o,icon:i,$size:n,...t,ref:l}):null);s.displayName="Icon";var v=r(s)``;

export { s as a, v as b };
